<template>
  <transition name="fade">
    <div v-if="isOpen" class="modal-wrapper">
      <div
        class="overlay"
        @click.self="isOpen = false"
      ></div>

      <div class="modal">
        <div class="modal-content">
          <i class="icon icon-trashcan"/>
          {{ message }}
        </div>
        <div class="modal-footer">
          <Button
            outline
            @click="closeModal"
          >
            Cancel
          </Button>

          <Button
            primary
            @click="confirm"
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import Button from '@/components/common/Button'

@Component({
  name: 'ConfirmationModal',
  components: {
    Button
  }
})
class ConfirmationModal extends Vue {
  @Prop({ default: false }) isOpen;
  @Prop({ default: 'Are you sure ?' }) message;

  closeModal() {
    this.$emit('close');
  }

  confirm() {
    this.$emit('confirm');
  }
}

export default ConfirmationModal
</script>

<style scoped lang="less">
@import '../../assets/less/globals';

.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  display: flex;
  align-items: bottom;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;

  z-index: 50;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);
}

.modal {
  position: relative;

  display: flex;
  flex-direction: column;
  width: min-content;
  height: min-content;
  max-width: 90%;
  max-height: 90%;//calc(100% - var(--mobile-menu-height));
  // margin-top: var(--mobile-menu-height);
  overflow-y: auto;
  z-index: 50;

  background-color: white;
  box-shadow:
    0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028),
    0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042),
    0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  border-radius: 5px;

  transition: all 0.2s ease-in;
}

.modal-content {
  flex-grow: 1;

  padding: var(--margin--medium) var(--margin--medium) 0 var(--margin--medium);

  color: var(--color-text);
  font-weight: 600;
  // font-size: var(--font-size--bigger);
  text-align: center;

  .icon {
    display: inline-block;
    width: 100%;
    padding: var(--margin--small) 0;

    color: var(--color-separation-border);
    font-size: 70px;
    text-align: center;
  }
}

.fade-leave-active,
.fade-enter-active {
  transition: all 0.3s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media screen and (min-width: @screen-desktop-low) {
  .modal-wrapper {
    align-items: center;
  }

  .modal {
    bottom: auto;
    margin-top: 0;
    margin-bottom: 0;

    min-width: 300px;
    max-width: 85%;
    min-height: 300px;
  }

  .modal-footer {
    display: flex;
    justify-content: space-between;
    padding: var(--margin--medium);

    button {
      padding: var(--margin--small);
      border-radius: 5px;
    }
  }
}
</style>
